module.exports = __webpack_public_path__ + "static/media/game-press-symbol-global.34a6f8c6.png";